import type { PresenceLayerAuthorshipInput } from '../types';

function firstCell(value: unknown): unknown {
    if (Array.isArray(value)) return value.length > 0 ? value[0] : value;
    if (value !== null && typeof value === 'object' && Object.prototype.hasOwnProperty.call(value, '0')) {
        return (value as Record<string, unknown>)['0'];
    }
    return value;
}

/** Mirror ft_node_authors_presence_layer after the caller supplies the two raw candidate slots. */
export function authorsPresenceLayer(input: PresenceLayerAuthorshipInput): boolean {
    const raw = firstCell(input.bucketValue ?? input.rootValue);
    if (raw === undefined || raw === null || raw === '' || raw === 0 || raw === '0' || raw === false) return false;
    if (Array.isArray(raw)) return raw.length > 0;
    if (typeof raw === 'object') return raw !== null && Object.keys(raw).length > 0;
    return true;
}
